/* Иконки VinoWay DS, используемые в админке (README хендоффа, «Ассеты»). */
import { createIcon } from './createIcon';
import { ICON_PATHS } from './iconPaths';

export const IconArrowRight = createIcon('IconArrowRight', ICON_PATHS.IconArrowRight);
export const IconAward = createIcon('IconAward', ICON_PATHS.IconAward);
export const IconBag = createIcon('IconBag', ICON_PATHS.IconBag);
export const IconBell = createIcon('IconBell', ICON_PATHS.IconBell);
export const IconBodega = createIcon('IconBodega', ICON_PATHS.IconBodega);
export const IconBook = createIcon('IconBook', ICON_PATHS.IconBook);
export const IconCalendar = createIcon('IconCalendar', ICON_PATHS.IconCalendar);
export const IconCard = createIcon('IconCard', ICON_PATHS.IconCard);
export const IconCart = createIcon('IconCart', ICON_PATHS.IconCart);
export const IconCheck = createIcon('IconCheck', ICON_PATHS.IconCheck);
export const IconClose = createIcon('IconClose', ICON_PATHS.IconClose);
export const IconCrown = createIcon('IconCrown', ICON_PATHS.IconCrown);
export const IconDanger = createIcon('IconDanger', ICON_PATHS.IconDanger);
export const IconDocument = createIcon('IconDocument', ICON_PATHS.IconDocument);
export const IconEye = createIcon('IconEye', ICON_PATHS.IconEye);
export const IconFilter = createIcon('IconFilter', ICON_PATHS.IconFilter);
export const IconGallery = createIcon('IconGallery', ICON_PATHS.IconGallery);
export const IconGlass = createIcon('IconGlass', ICON_PATHS.IconGlass);
export const IconGps = createIcon('IconGps', ICON_PATHS.IconGps);
export const IconHome = createIcon('IconHome', ICON_PATHS.IconHome);
export const IconInfo = createIcon('IconInfo', ICON_PATHS.IconInfo);
export const IconLock = createIcon('IconLock', ICON_PATHS.IconLock);
export const IconMap = createIcon('IconMap', ICON_PATHS.IconMap);
export const IconMedal = createIcon('IconMedal', ICON_PATHS.IconMedal);
export const IconProfile = createIcon('IconProfile', ICON_PATHS.IconProfile);
export const IconRefresh = createIcon('IconRefresh', ICON_PATHS.IconRefresh);
export const IconRoute = createIcon('IconRoute', ICON_PATHS.IconRoute);
export const IconSearch = createIcon('IconSearch', ICON_PATHS.IconSearch);
export const IconSettings = createIcon('IconSettings', ICON_PATHS.IconSettings);
export const IconShop = createIcon('IconShop', ICON_PATHS.IconShop);
export const IconStar = createIcon('IconStar', ICON_PATHS.IconStar);
export const IconTeacher = createIcon('IconTeacher', ICON_PATHS.IconTeacher);
export const IconTicket = createIcon('IconTicket', ICON_PATHS.IconTicket);
export const IconTimer = createIcon('IconTimer', ICON_PATHS.IconTimer);
export const IconUsers = createIcon('IconUsers', ICON_PATHS.IconUsers);
export const IconVerify = createIcon('IconVerify', ICON_PATHS.IconVerify);
export const IconWineBottle = createIcon('IconWineBottle', ICON_PATHS.IconWineBottle);
export const IconWineBottleGlass = createIcon(
  'IconWineBottleGlass',
  ICON_PATHS.IconWineBottleGlass,
);
export const IconWineglass = createIcon('IconWineglass', ICON_PATHS.IconWineglass);
